import VerifiedBadgeIcon from '@kijiji/icons/src/icons/VerifiedBadge'
import { type FC } from 'react'
import { useTheme } from 'styled-components'

import { BodyText } from '@/ui/atoms/body-text'
import { Flex } from '@/ui/atoms/flex'
import { Star } from '@/ui/atoms/star-meter/styled'

type ListingPosterReviewProps = {
  rating?: number | null
  verified?: boolean | null
}

export const ListingPosterReview: FC<ListingPosterReviewProps> = ({ rating, verified }) => {
  const { colors, spacing } = useTheme()

  if (!rating && !verified) return null

  return (
    <Flex alignItems="center" gap={spacing.mini}>
      {rating ? (
        <>
          <Star $length={1} $size="small" aria-hidden color={colors.grey.light1} />
          <BodyText size="xSmall" color={colors.grey.light1}>
            {rating.toFixed(1)}
          </BodyText>
        </>
      ) : null}
      {verified ? (
        <VerifiedBadgeIcon
          aria-hidden
          color={colors.blue.primary}
          data-testid="listing-verified-badge"
          width={14}
        />
      ) : null}
    </Flex>
  )
}
